<app-view-by-attribute
        (entityLoaded)="entityLoadedInComponent($event)"
        [findByAttributeService]="findByIdService"
        [value]="id">
    <ng-content></ng-content>
</app-view-by-attribute>
